import { z } from 'zod';
import { IdSchema } from './encoding.js';
import { NotificationDeliveryStatusSchema } from './notifications.js';
/**
 * Integration contracts (SDD §20, §3.4 TD-03; FRD-INT-002, INT-011, INT-014).
 *
 * Release 1 delivers only the integrations FRD-INT-006 names: outbound e-mail for notifications
 * and AI services. These contracts cover resending a failed e-mail and the published API
 * description. They add no connector, webhook or client-credential surface (SDD §20.3).
 */
/** The outcome of resending a failed e-mail notification: it is queued again (FRD-INT-014). */
export const EmailResendResultSchema = z.object({
    id: IdSchema,
    deliveryStatus: NotificationDeliveryStatusSchema,
    attempts: z.number().int(),
    failureReason: z.string().nullable(),
});
export const API_OPERATION_METHODS = ['get', 'post', 'put', 'patch', 'delete'];
/** One operation of the API, as the in-application API description lists it. */
export const ApiOperationSchema = z.object({
    method: z.enum(API_OPERATION_METHODS),
    path: z.string(),
    operationId: z.string(),
    /** The owning area: the first path segment after the version (`hr`, `platform`, …). */
    tag: z.string(),
    /** `<recordType>:<action>`, or null for a public route (sign-in, health). */
    permission: z.string().nullable(),
    /** True when the route validates a request body against a contracts schema. */
    requestBody: z.boolean(),
    /** True when the route validates its query string against a contracts schema. */
    queryParameters: z.boolean(),
});
/**
 * The API description: an OpenAPI 3.1 document generated from the running routes and the
 * contracts' zod schemas (SDD §3.4, TD-03), with the operations listed in `x-operations` for the
 * page. The document is published as generated, so its paths and components stay loosely typed.
 */
export const ApiDescriptionSchema = z.object({
    openapi: z.string(),
    info: z.object({ title: z.string(), version: z.string(), description: z.string() }),
    paths: z.record(z.string(), z.record(z.string(), z.unknown())),
    components: z.record(z.string(), z.unknown()),
    'x-operations': z.array(ApiOperationSchema),
});
//# sourceMappingURL=integration.js.map